import {
	API_GET_ALL_EMERGENCY_REASON,
	API_GET_ALL_EMERGENCY_REASON_SUCCESS,
	API_GET_ALL_EMERGENCY_REASON_FAIL,
} from '../actions/emergencyReason';
import { createReducer } from '@reduxjs/toolkit';
import { ErrorAction, errorHandler } from 'utils/error';

const initialState = {
	loading: false,
	list: [],
};

const emergencyReasons = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_EMERGENCY_REASON]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_EMERGENCY_REASON_FAIL]: (state, action) => {
		errorHandler("Motif d'urgence", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_EMERGENCY_REASON_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
});

export default emergencyReasons;
